var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m17.714 2.074-2.712 1.387 1.284 2.613"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22 8.074a5.941 5.941 0 0 0-1.47-2.165c-1.372-1.255-3.263-1.887-5.177-1.73M6.431 22l2.711-1.387L7.86 18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.146 16c.315.812.814 1.55 1.464 2.165 1.373 1.259 3.265 1.896 5.183 1.745"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M8.906 12v-.3h-.37c-.317 0-.567-.053-.75-.158-.184-.106-.307-.229-.37-.37-.063-.14-.094-.492-.094-1.054V1.633h.83c.519 0 .883.048 1.091.146.372.178.665.418.879.718.213.3.407.793.582 1.48H11V1H1v2.977h.312c.126-.811.427-1.436.903-1.874.34-.313.884-.47 1.634-.47h.805v8.485c0 .552-.03.892-.09 1.022a.778.778 0 0 1-.337.39c-.197.113-.457.17-.78.17h-.37v.3h5.83zm12 11v-.3h-.37c-.317 0-.567-.053-.75-.158-.184-.106-.307-.229-.37-.37-.063-.14-.094-.492-.094-1.054v-8.485h.83c.519 0 .883.048 1.091.146.372.178.665.418.879.718.213.3.407.793.582 1.48H23V12H13v2.977h.312c.126-.811.427-1.436.903-1.874.34-.313.884-.47 1.634-.47h.805v8.485c0 .552-.03.892-.09 1.022a.778.778 0 0 1-.337.39c-.197.113-.457.17-.78.17h-.37v.3h5.83z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.4a9c080d.svg";
export { ForwardRef as ReactComponent };